<template>
    <div @focusout="onFocusout($event)" ref="reference">
        <component ref="focusable" :id="id" tabindex="0" :is="wrapperTag" href="#" class="btn_select"
                   v-bind:class="innerWrapperClass"
                   @click="toggle($event)"
                   @keydown.esc.stop.prevent="close"
                   @keydown.up.stop.prevent="onKeydownUp"
                   @keydown.down.stop.prevent="onKeydownDown"
                   @keydown.enter.stop.prevent="onKeydownEnter($event)"
        >
            <TextInput type="text" ref="input" v-if="isInputMode" :value="value" wrapper-class="" @change="onInput"
                       v-bind="inputProps"/>
            <span
                v-else-if="initialLabel && (value === undefined || value === null)"
                class="placeholder"
            >{{initialLabel}}</span>
            <template v-else>
                {{label}}
            </template>
            <span v-if="isShowArrow" class="ico_select_arrow"></span>
        </component>

        <CustomSelectList ref="customSelectList"
                          :options="options"
                          :hover-index="hoverIndex"
                          :visibleArrow="false"
                          :appendToBody="false"
                          :placement="placement"
                          :popper-options="popperOptions"
                          v-on:selectOption="selectOption"
                          v-bind:style="{'min-width': listWidth}"
        />
    </div>
</template>

<script>
import CustomSelectList from './CustomSelect/CustomSelectList.vue';
import TextInput from "@/iamteacherpc/components/common/TextInput.vue";

export default {
    name: "CustomSelect",

    components: {
        TextInput,
        CustomSelectList,
    },

    props: {
        id: {
            type: String,
            },
            value: {
            },
            wrapperClass: {
                type: Array,
                default() {
                    return [];
                }
            },
            options: {
                type: Array,
                required: true
            },
            placement: {
                type: String,
                default() {
                    return 'bottom-start'
                }
            },
            isShowArrow: {
                type: Boolean,
                default() {
                    return true
                },
            },
        fitWidth: {
            type: Boolean,
            default() {
                return true
            },
        },
        initialLabel: {
            type: String,
        },
        inputProps: {},
    },

        data() {
            return {
                isShow: false,
                popperOptions: {
                    // modifiers: ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', this.popperOffset, 'applyStyle']
                },
                isContainInput: this.options.some(option => option.value === '__INPUT__'),
                hoverIndex: -1,
                isInputMode: false,
                listWidth: undefined
            }
        },

        mounted() {
            this.isInputMode = this.determineInputMode();
            this.resetHoverIndex();
        },

        watch: {
            value(newValue) {
                this.isInputMode = this.determineInputMode();
                this.resetHoverIndex();
            },

            isShow(newValue) {
                if (newValue) {
                    this.resetHoverIndex();

                    this.$nextTick(function () {
                        if (this.fitWidth) {
                            this.listWidth = this.$el.getBoundingClientRect().width + 'px';
                        }
                    });
                } else {
                    this.hoverIndex = -1;
                }
            }
        },

        computed: {
            label() {
                const index = this.findHoverIndex();

                if (index === -1) {
                    return '';
                }

                return this.options[index].label;
            },

            wrapperTag() {
                return this.isInputMode ? 'span' : 'a';
            },

            innerWrapperClass() {
                return [
                    ...this.wrapperClass,
                    ...(this.isShow ? ['on'] : [])
                ];
            }
        },

        methods: {
            toggle(event) {
                if (this.isInputMode) {
                    if (this.$refs.input.$el.contains(event.target)) {
                        return;
                    }

                    this.onInput(this.$refs.input.getValue());
                }

                event.preventDefault();
                this.isShow = !this.isShow;
            },

            close() {
                this.isShow = false;
            },

            selectOption(index) {
                const value = this.options[index].value;

                if (value === '__INPUT__') {
                    if (!this.isInputMode) {
                        this.$emit('input', '');
                    }

                    this.$nextTick(function () {
                        this.$refs.input.focus();
                    });

                    this.isInputMode = true;
                } else {
                    this.isInputMode = false;
                    this.$emit('input', this.options[index].value);
                    this.$nextTick(function () {
                        this.$refs.focusable.focus();
                    });
                }

                this.hoverIndex = index;
                this.close();
            },

            determineInputMode() {
                const index = this.findHoverIndex();
                return index === -1 && this.isContainInput;
            },

            onInput(newValue) {
                this.$emit('input', newValue);
            },

            onFocusout(event) {
                if (this.$el.contains(event.relatedTarget)) {
                    return;
                }

                this.close();
            },

            onKeydownUp() {
                let nextIndex = this.hoverIndex - 1;

                if (nextIndex < 0) {
                    nextIndex = this.options.length - 1;
                }

                this.hoverIndex = nextIndex;
            },

            onKeydownDown() {
                let nextIndex = this.hoverIndex + 1;

                if (nextIndex > this.options.length - 1) {
                    nextIndex = 0;
                }

                this.hoverIndex = nextIndex;
            },

            onKeydownEnter(event) {
                if (this.isShow) {
                    this.selectOption(this.hoverIndex);
                } else {
                    this.toggle(event);
                }
            },

            resetHoverIndex() {
                if (this.isInputMode) {
                    this.hoverIndex = this.findValueIndex('__INPUT__');
                } else {
                    this.hoverIndex = this.findHoverIndex();
                }
            },

            findHoverIndex() {
                return this.findValueIndex(this.value);
            },

            findValueIndex(value) {
                return this.options.findIndex(option => option.value === value);
            },

            popperOffset(data) {
                const doc = document.documentElement;
                const top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);

                if (data.placement.indexOf('bottom') > -1) {
                    data.offsets.popper.top = data.offsets.reference.bottom - top;
                    // data.offsets.popper.top -= 1;
                } else {
                    data.offsets.popper.top = data.offsets.reference.top - data.offsets.popper.height - top;
                    // data.offsets.popper.top += 1;
                }

                data.offsets.popper.position = 'fixed';

                return data;
            },
        }
    }
</script>

<style scoped>

</style>
